module.exports = __webpack_public_path__ + "media/customizations/babcockranch/back-2ecbf2d336c5ed78655de45246fd277f.jpg";